import { createPerfilApi } from "@/contexts/autorizacao/perfil/api/perfilApi";
import { useAuth } from "react-oidc-context";

export const usePerfil = () => {
  const { user } = useAuth();
  const perfilApi = createPerfilApi(user?.access_token);

  return {
    updatePermissoesPerfilApi: perfilApi.updatePermissoes,
    getPerfisApi: perfilApi.listAll,
    getPermissoesByPerfilIdApi: perfilApi.getPermissoes,
  };
};
